import variationsFor from './variationsFor'

const types = {
  ...variationsFor('GET_USERS')
}

export default types
